const keys = {
  commonRedirectionToPartner: {
    none: 'No partner',
    jaLemieux: {
      name: 'Telio Insurance',
    },
    mitchellAbbottGroup: {
      name: 'Mitchell & Abbott Group',
    },
    sgb: {
      name: 'ESSOR Insurance',
    },
    verge: {
      name: 'Verge Insurance',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
